<template>
  <div class="contact-block">
    <div class="contact-block__inner container flex j_sb">
      <div class="contact-block__left-col">
        <h2 class="f-24 bold uppercase wc-lg">{{ _.get(content, "title") }}</h2>

        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="contact__form"
          v-show="!success_sent"
        >
          <el-form-item prop="name">
            <span
              class="f-16 medium el-input__placeholder el-input__placeholder--name"
              :class="{ selected: ruleForm.name.length !== 0 }"
              >{{ $fn.tr("სახელი, გვარი") }}</span
            >
            <el-input
              v-model="ruleForm.name"
              @focus="add_focus('name')"
              @blur="remove_focus('name', ruleForm.name)"
            ></el-input>
          </el-form-item>

          <el-form-item prop="email">
            <span
              class="f-16 medium el-input__placeholder el-input__placeholder--email"
              :class="{ selected: ruleForm.email.length !== 0 }"
              >{{ $fn.tr("ელ-ფოსტა") }}</span
            >
            <el-input
              v-model="ruleForm.email"
              type="email"
              @focus="add_focus('email')"
              @blur="remove_focus('email', ruleForm.email)"
            ></el-input>
          </el-form-item>

          <el-form-item prop="product">
            <el-select
              v-model="ruleForm.product"
              :placeholder="$fn.tr('აირჩიე პროდუქტი')"
              :popper-append-to-body="false"
              @visible-change="
                $store.state.main.stop_scroll = !$store.state.main.stop_scroll
              "
            >
              <el-option
                v-for="item in _.get(contentData, 'data.list')"
                :key="item.id"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="phone">
            <span
              class="f-16 medium el-input__placeholder el-input__placeholder--phone"
              :class="{ selected: ruleForm.phone.length !== 0 }"
              >{{ $fn.tr("ნომერი") }}</span
            >

            <el-input
              v-model.number="ruleForm.phone"
              @focus="add_focus('phone')"
              @blur="remove_focus('phone', ruleForm.phone)"
            ></el-input>
          </el-form-item>

          <el-form-item prop="desc">
            <span
              class="f-16 medium el-input__placeholder el-input__placeholder--textarea"
              :class="{ selected: ruleForm.desc.length !== 0 }"
              >{{ $fn.tr("შეტყობინება") }}</span
            >

            <el-input
              type="textarea"
              v-model="ruleForm.desc"
              @focus="add_focus('textarea')"
              @blur="remove_focus('textarea', ruleForm.desc)"
            ></el-input>
          </el-form-item>

          <div class="contact-block__accept-terms wc-lg">
            <span class="f-16 regular">{{ _.get(content, "teaser") }}</span>
            <a :href="_.get(content, 'full_list_url')" class="f-cyan underline">
              {{ _.get(content, "full_list_title") }}
            </a>
          </div>
          <el-form-item>
            <el-button
              class="button contact-block__validate_button wc-lg"
              @click="submitForm('ruleForm')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                  fill="#fff"
                />
              </svg>
              <span class="f-16 bold uppercase f-white">{{
                $fn.tr("გაგზავნა")
              }}</span>
            </el-button>
          </el-form-item>
        </el-form>

        <div class="contact-block__success wc-lg" v-show="success_sent">
          <h2 class="f-38 bold">
            {{ $fn.tr("შეტყობინება წარმატებით გაიგზავნა") }}
          </h2>
          <div
            class="button contact-block__validate_button  f-white uppercase f-14 bold pointer"
            @click="success_sent = !success_sent"
          >
            {{ $fn.tr("უკან დაბრუნება") }}
          </div>
        </div>
      </div>
      <div class="contact-block__right-col flex column wc-lg">
        <div
          class="contact-block__card flex column bg-white br-12 pointer"
          @click="
            $store.state.main.anonymous_complaint_modal = !$store.state.main
              .anonymous_complaint_modal
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
          >
            <g
              id="Group_3572"
              data-name="Group 3572"
              transform="translate(-8 -6.5)"
            >
              <circle
                id="Oval"
                cx="24"
                cy="24"
                r="24"
                transform="translate(8 6.5)"
                fill="#7063e9"
              />
              <g
                id="_61_igno"
                data-name="61 igno"
                transform="translate(9.889 8.119)"
              >
                <path
                  id="Path_2244"
                  data-name="Path 2244"
                  d="M16.54,13.22A2.6,2.6,0,0,1,18.746,12h6.73a2.6,2.6,0,0,1,2.206,1.22L30.7,18.055H13.521ZM28.166,32.761a4.325,4.325,0,0,1-4.325-4.014A2.111,2.111,0,0,0,22.111,28a2.111,2.111,0,0,0-1.73.744,4.265,4.265,0,1,1-.3-1.99,4.654,4.654,0,0,1,4.135,0,4.325,4.325,0,1,1,3.953,6Zm5.19-12.111H10.865a.865.865,0,1,1,0-1.73H33.357a.865.865,0,0,1,0,1.73Z"
                  transform="translate(0 0)"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>

          <h2 class="f-18 bold">{{ $fn.tr("ანონიმური მხილება") }}</h2>
          <p class="regular">{{ $fn.tr("ანონიმური მხილების თიზერი") }}</p>
        </div>
        <div
          class="contact-block__card flex column br-12 pointer"
          @click="
            $store.state.main.complaint_modal = !$store.state.main
              .complaint_modal
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
          >
            <g
              id="Group_3572"
              data-name="Group 3572"
              transform="translate(-8 -9.5)"
            >
              <circle
                id="Oval"
                cx="24"
                cy="24"
                r="24"
                transform="translate(8 9.5)"
                fill="#7063e9"
              />
              <g id="Dislike" transform="translate(10.984 20.137)">
                <path
                  id="Path_2245"
                  data-name="Path 2245"
                  d="M48.169,11.934h.244a1.572,1.572,0,0,1,0,3.145H43.424a.465.465,0,0,0-.461.542c.325,2.169.786,2.9,1,5.151a1.678,1.678,0,0,1-3.307.542c-.84-3.741-3.931-6.235-4.934-6.994a.773.773,0,0,1-.325-.651V4.723a.8.8,0,0,1,.488-.732A11.285,11.285,0,0,1,41.933,2.5h5.747a1.572,1.572,0,0,1,0,3.145h.19A1.634,1.634,0,0,1,49.5,7a1.583,1.583,0,0,1-1.572,1.789h.19a1.634,1.634,0,0,1,1.627,1.355A1.584,1.584,0,0,1,48.169,11.934Z"
                  transform="translate(-17.931)"
                  fill="#fff"
                />
                <path
                  id="Path_2246"
                  data-name="Path 2246"
                  d="M16.249,17.982v-8.3a.787.787,0,0,0-.786-.786H11.586a.787.787,0,0,0-.786.786v8.3a.787.787,0,0,0,.786.786h3.877A.787.787,0,0,0,16.249,17.982ZM14.378,11.5a.84.84,0,1,1-.84-.84A.811.811,0,0,1,14.378,11.5Z"
                  transform="translate(0 -4.665)"
                  fill="#fff"
                />
                <path
                  id="Path_2247"
                  data-name="Path 2247"
                  d="M58.364,84.6a.856.856,0,0,1,.868.868V87.2a.868.868,0,1,1-1.735,0V85.468A.856.856,0,0,1,58.364,84.6Z"
                  transform="translate(-34.036 -59.843)"
                  fill="#fff"
                />
                <path
                  id="Path_2248"
                  data-name="Path 2248"
                  d="M41.436,79.744a.919.919,0,0,1,1.247,0,.868.868,0,0,1,0,1.247l-1.247,1.247a.882.882,0,0,1-1.247-1.247Z"
                  transform="translate(-21.229 -56.126)"
                  fill="#fff"
                />
                <path
                  id="Path_2249"
                  data-name="Path 2249"
                  d="M70.913,79.1a.9.9,0,0,1,.624.244l1.247,1.247a.882.882,0,1,1-1.247,1.247l-1.247-1.247a.868.868,0,0,1,0-1.247A1.123,1.123,0,0,1,70.913,79.1Z"
                  transform="translate(-43.169 -55.834)"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>

          <h2 class="f-18 bold">{{ $fn.tr("პრეტენზიის დაფიქსირება") }}</h2>
          <p class="regular">{{ $fn.tr("პრეტენზიის დაფიქსირების თიზერი") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fn from "@/helpers/func";
export default {
  props: ["contentData"],
  data() {
    let validate_phone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
        } else {
          callback();
        }
      }, 1000);
    };
    let validate_name = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      } else {
        callback();
      }
    };
    let validate_product = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      } else {
        callback();
      }
    };

    let validate_desc = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      } else {
        callback();
      }
    };
    let validate_email = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      }
      setTimeout(() => {
        if (!value.includes("@")) {
          callback(new Error(this.$fn.tr("გთხოვთ სწორად შეიყვანოთ იმეილი")));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      success_sent: false,
      focuses: [],

      ruleForm: {
        name: "",
        product: "",

        email: "",
        phone: "",

        desc: ""
      },
      rules: {
        name: [{ validator: validate_name, trigger: "blur" }],
        product: [{ validator: validate_product, trigger: "blur" }],

        email: [{ validator: validate_email, trigger: "blur" }],
        phone: [{ validator: validate_phone, trigger: "blur" }],
        desc: [{ validator: validate_desc, trigger: "blur" }]
      }
    };
  },
  mounted() {
    console.log(this.content);
  },
  computed: {
    content() {
      return _.get(this.contentData, "conf.header");
    }
  },
  methods: {
    add_focus(name) {
      let _name = document.querySelector(".el-input__placeholder--name");
      let _email = document.querySelector(".el-input__placeholder--email");
      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      if (!this.focuses.includes(name)) this.focuses.push(name);
      if (name == "name") {
        _name.classList.add("selected");
      } else if (name == "email") {
        _email.classList.add("selected");
      } else if (name == "phone") {
        _phone.classList.add("selected");
      } else if (name == "textarea") {
        _textarea.classList.add("selected");
      }
    },
    remove_focus(name, field) {
      this.focuses = this.focuses.filter(foc => foc !== name);
      let _name = document.querySelector(".el-input__placeholder--name");
      let _email = document.querySelector(".el-input__placeholder--email");
      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      if (field.length == 0) {
        if (name == "name") {
          _name.classList.remove("selected");
        } else if (name == "email") {
          _email.classList.remove("selected");
        } else if (name == "phone") {
          _phone.classList.remove("selected");
        } else if (name == "textarea") {
          _textarea.classList.remove("selected");
        }
      }
    },
    async submit_form() {
      let params = {
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        email: this.ruleForm.email,
        product: this.ruleForm.product,
        text: this.ruleForm.desc,
        formType: "contact_form"
      };

      let res = await fn.postData("main/saveSubmitedForm", params);
      this.success_sent = true;
      console.log(res);
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit_form();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style></style>
